const pattern = /^([0-9]+)-?.*/;

/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param: string) {
  return pattern.test(param);
}

export function parseId(value: string | null) {
  const match = `${value}`.match(pattern);

  if (match) {
    const [_, id] = match;

    return id;
  }

  return null;
}
